import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { demoPatient, demoConsultation } from "../demo/demoData";

export default function DemoConsultation() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 p-4 sm:p-6">
      <div className="max-w-4xl mx-auto space-y-4">
        <p className="text-xs font-medium text-slate-500 text-center tracking-wide">
          Consulta → Documento → Empezar
        </p>
        <p className="text-sm text-slate-600 text-center max-w-2xl mx-auto">
          Aurora organiza la consulta y resume los hallazgos clave automáticamente
        </p>
        <Badge className="bg-amber-100 text-amber-800 border-amber-200">Esta es una consulta de demostracion</Badge>

        <Card className="border-slate-200">
          <CardHeader>
            <CardTitle className="text-xl text-slate-900">{demoPatient.nombre}</CardTitle>
            <p className="text-sm text-slate-600">
              {demoPatient.edad} anos · {demoPatient.sexo} · Fecha {demoConsultation.fecha}
            </p>
          </CardHeader>
        </Card>

        <Card className="border-slate-200">
          <CardHeader className="pb-2">
            <CardTitle className="text-base">Motivo de consulta</CardTitle>
          </CardHeader>
          <CardContent className="text-sm text-slate-700">{demoConsultation.motivo}</CardContent>
        </Card>

        <Card className="border-slate-200">
          <CardHeader className="pb-2">
            <CardTitle className="text-base">Antecedentes relevantes</CardTitle>
          </CardHeader>
          <CardContent>
            <ul className="list-disc pl-5 space-y-1 text-sm text-slate-700">
              {demoConsultation.antecedentes.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </CardContent>
        </Card>

        <Card className="border-slate-200">
          <CardHeader className="pb-2">
            <CardTitle className="text-base">Escalas completadas</CardTitle>
          </CardHeader>
          <CardContent className="grid sm:grid-cols-2 gap-3">
            {demoConsultation.escalas.map((s) => (
              <div key={s.nombre} className="rounded-lg border border-slate-200 p-3 bg-white">
                <p className="text-sm font-semibold text-slate-800">{s.nombre}</p>
                <p className="text-sm text-slate-700 mt-1">{s.valor}</p>
                <p className="text-xs text-slate-500 mt-1">{s.interpretacion}</p>
              </div>
            ))}
          </CardContent>
        </Card>

        <Card className="border-slate-200">
          <CardHeader className="pb-2">
            <CardTitle className="text-base">Resumen clinico</CardTitle>
          </CardHeader>
          <CardContent className="text-sm text-slate-700">{demoConsultation.resumenClinico}</CardContent>
        </Card>

        <div className="flex flex-wrap gap-2 justify-end">
          <Button variant="outline" onClick={() => navigate("/demo-clinico")}>
            Volver
          </Button>
          <Button className="bg-slate-800 hover:bg-slate-700" onClick={() => navigate("/demo-clinico/documento")}>
            Abrir documento
          </Button>
        </div>
      </div>
    </div>
  );
}
